const ICON_PRIMARY_COLOR = '#2196f3';

export { ICON_PRIMARY_COLOR };
